import styled from 'styled-components'

export const ValueWrapper = styled.div`
	display: flex;
	column-gap: 6px;
	row-gap: 10px;
	flex-wrap: wrap;
	width: 100%;
	min-width: 0;
`
